import { render } from "./RelinkAccountsPage.vue?vue&type=template&id=1a27cf82&scoped=true"
import script from "./RelinkAccountsPage.vue?vue&type=script&lang=js"
export * from "./RelinkAccountsPage.vue?vue&type=script&lang=js"

import "./RelinkAccountsPage.vue?vue&type=style&index=0&id=1a27cf82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a27cf82"]])

export default __exports__